<template>
    <modal-controller-base contentClass="light-light-background purple-purple-color">
        <template #header>
            <custom-header back-button :title="$t('titleRoute.skipEmail')">
                <template #start>
                    <ion-button
                        @click="modalController.dismiss()"
                        class="purple-light-color"
                    >
                        <ion-icon :icon="chevronBack" />
                        {{ $t('button.back') }}
                    </ion-button>
                </template>
            </custom-header>
        </template>

        <div class="d-flex flex-d-c max-size p-3 center-y">
            <div class="flex-grow-1 center flex-d-c">
                <div class="pb-3 ion-text-center fw-b">
                    {{ $t('messages.register.skipEmail') }}
                </div>

                <input-simple
                    v-model="confirmEmail"
                    class="grey4-grey4-background inherit-background purple-purple-color input-border"
                    :placeholder="`${$t('placeholder.email')}*`"
                    :debounce="500"
                >
                    <template #error-message v-if="!!confirmEmail && confirmEmail !== registerData.email">
                        {{ $t('error.noMatch', { target: $t('placeholder.email') }) }}
                    </template>
                </input-simple>
            </div>

            <div class="d-flex pt-3 ion-align-items-end max-width">
                <div class="d-flex ion-justify-content-evenly max-width">
                    <button-base
                        class="register-button"
                        @click="modalController.dismiss(undefined, 'cancel')"
                    >
                        {{ $t('button.cancel') }}
                    </button-base>

                    <button-base
                        :disabled="!confirmEmail || confirmEmail !== registerData.email"
                        class="register-button"
                        @click="forceEmailRegister"
                    >
                        {{ $t('button.ok') }}
                    </button-base>
                </div>
            </div>
        </div>
    </modal-controller-base>
</template>

<script setup lang="ts">import { ref as _ref } from 'vue';

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { chevronBack } from "ionicons/icons";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import InputSimple from "@/components/input/InputSimple.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { RegisterData } from "@/types/functions";
import { useRegister } from "@/composables/viewFunctions/useLogin";

const props = defineProps<{ registerData: RegisterData; formInterface: any }>()

const { registerUser } = useRegister()

const confirmEmail = _ref<string>('')

const forceEmailRegister = async () => {
    await registerUser(props.registerData, props.formInterface, true)
    if ((await modalController.getTop())) await modalController.dismiss()
}
</script>

<style scoped>
.register-button {
    min-width: 110px;
}
</style>
